import React from 'react';
import { Chip } from '@mui/material';

const EXAM_TYPE_CHIP_STYLES = {
  mcq: { bgcolor: '#ECFDF5', color: '#10B981', label: 'MCQ' },
  essay: { bgcolor: '#EFF6FF', color: '#2563EB', label: 'ESSAY' },
  structure: { bgcolor: '#FFF7ED', color: '#EA580C', label: 'STRUCTURED' },
  mixed: { bgcolor: '#FEF9C3', color: '#854D0E', label: 'MIXED' }
};

export const getExamTypeChipStyle = (type) => {
  let normalized = (type || '').toLowerCase();
  if (normalized === 'structured') {
    normalized = 'structure';
  }
  return EXAM_TYPE_CHIP_STYLES[normalized] || {
    bgcolor: '#f1f5f9',
    color: '#64748b',
    label: (type || 'Unknown').toUpperCase()
  };
};

export default function ExamTypeChip({ type, sx = {} }) {
  const { bgcolor, color, label } = getExamTypeChipStyle(type);

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        bgcolor,
        color,
        fontWeight: 700,
        fontFamily: 'Poppins',
        borderRadius: '8px',
        fontSize: '11px',
        height: '24px',
        px: 1,
        ...sx
      }}
    />
  );
}
